// Setup hint (COMMERCE_ONBOARDING Phase 2 · §177) — a small empty-state prompt that
// deep-links back to the onboarding step that turns this surface on. Drop into a view's
// empty state: <SetupHint what="products" route="/Setup" />. Renders nothing once the
// relevant step is done, so it never shows on a set-up workspace.

import React from "react";
import { withRouter } from "react-router";
import { getOnboardingStatus } from "../../functions/onboarding-status";
import { OB_CSS } from "./onboarding-css";

// what → { step key that turns it on, copy, route }
const HINTS = {
  products: {
    step: "products",
    route: "/Setup",
    line: "Connect your product catalog and this fills in: a feed, a CSV, or a few by hand."
  },
  tracker: {
    step: "tracker",
    route: "/Tracking",
    line: "Install the Plunk tracker and site activity starts flowing from the moment it's live."
  },
  contacts: {
    step: "customers",
    route: "/Setup",
    line: "Contacts build automatically once your tracker and event scripts are live, or bring a list."
  },
  sales: {
    step: "sales",
    route: "/Setup",
    line: "Connect your sales history to turn on top sellers, forecasts and store performance."
  },
  setup: {
    step: null,
    route: "/Setup",
    line: "Finish connecting your data and this turns on."
  }
};
class SetupHint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ob: null
    };
    this._alive = true;
  }
  async componentDidMount() {
    const ob = await getOnboardingStatus().catch(() => null);
    if (this._alive) this.setState({
      ob
    });
  }
  componentWillUnmount() {
    this._alive = false;
  }
  render() {
    const {
      ob
    } = this.state;
    const h = HINTS[this.props.what] || HINTS.setup;
    // Once the step that powers this surface is done, don't nag.
    if (ob && h.step && ob.steps && ob.steps[h.step]) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "ob-root",
      style: {
        padding: 0
      }
    }, /*#__PURE__*/React.createElement("style", null, OB_CSS), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 12,
        alignItems: "center",
        flexWrap: "wrap",
        border: "1px solid var(--ob-border-strong)",
        background: "var(--ob-surface)",
        borderRadius: 12,
        padding: "12px 15px",
        boxShadow: "var(--ob-shadow)",
        maxWidth: 640
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons",
      style: {
        color: "var(--ob-primary)",
        fontSize: 22
      }
    }, "rocket_launch"), /*#__PURE__*/React.createElement("span", {
      style: {
        flex: "1 1 300px",
        fontSize: 13,
        color: "var(--ob-muted)"
      }
    }, this.props.line || h.line), /*#__PURE__*/React.createElement("button", {
      className: "ob-btn sm",
      onClick: () => this.props.history.push(h.route)
    }, this.props.cta || "Finish setup")));
  }
}
export default withRouter(SetupHint);
export const SetupHint_ = withRouter(SetupHint);